import { useWaitlistSignup } from '../hooks/useWaitlistSignup';
import { cx } from '../lib/cx';
import { FADE_UP } from '../styles/animation';
import { PendingPanel } from './PendingPanel';
import { StatePanel } from './StatePanel';
import { WaitlistForm } from './WaitlistForm';
import styles from './WaitlistCard.module.css';

interface WaitlistCardProps {
  /**
   * True when the visitor arrived from the double opt-in email link. Skips straight to the
   * confirmed state instead of showing a form they have already completed.
   */
  confirmed: boolean;
}

/**
 * Owns which of the three views the card is showing: the form, the
 * "check your inbox" state after a successful submit, or the confirmed state
 * after the opt-in click.
 */
export function WaitlistCard({ confirmed }: WaitlistCardProps) {
  const { state, submit, reset, resend } = useWaitlistSignup();

  return (
    <div className={cx(FADE_UP, styles.card)}>
      {confirmed ? (
        <StatePanel icon="✓" title="You're on the list.">
          Thanks for joining the Creorank waitlist — we'll email you the moment the board opens.
        </StatePanel>
      ) : state.status === 'pending' ? (
        <PendingPanel email={state.email} onResend={resend} />
      ) : (
        <WaitlistForm
          busy={state.status === 'submitting'}
          errorMessage={state.status === 'error' ? state.message : undefined}
          onSubmit={(input) => void submit(input)}
          onEdit={reset}
        />
      )}
    </div>
  );
}
